import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceAction } from '../../../domain/enums/invoice-action.enum';
import { InvoiceActionRule } from '../../../domain/models/invoice-action-rule.model';
import { InvoiceCardVm } from '../../view-models/invoice-card.vm';

@Component({
  selector: 'app-invoice-card',
  templateUrl: './invoice-card.component.html',
  styleUrls: ['./invoice-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceCardComponent {
  @Input({ required: true }) card!: InvoiceCardVm;
  @Output() readonly actionSelected = new EventEmitter<InvoiceAction>();

  protected expanded = false;

  // ─── Derived state — all driven by InvoiceStatusRule, zero raw status checks ──

  get hasBanner(): boolean {
    return this.card.statusRule.banner !== null;
  }

  get showErrorBanner(): boolean {
    return this.card.statusRule.banner === 'error';
  }

  get showSupportBanner(): boolean {
    return this.card.statusRule.banner === 'support';
  }

  get detailsVisible(): boolean {
    return this.expanded || this.hasBanner;
  }

  /**
   * Returns a class map so the template stays free of logic.
   * Status-accent color + dimmed state are both config-driven.
   */
  get cardClasses(): Record<string, boolean> {
    const color = this.card.statusRule.color;
    return {
      'invoice-card--status-success':   color === 'success',
      'invoice-card--status-danger':    color === 'danger',
      'invoice-card--status-warning':   color === 'warning',
      'invoice-card--status-info':      color === 'info',
      'invoice-card--status-secondary': color === 'secondary',
      'invoice-card--dimmed':           this.card.statusRule.dimmed,
    };
  }

  // ─── Event handlers ───────────────────────────────────────────────────────────

  onActionSelected(action: InvoiceAction): void {
    this.actionSelected.emit(action);
  }

  selectAction(rule: InvoiceActionRule): void {
    if (rule.enabled) {
      this.actionSelected.emit(rule.action);
    }
  }

  toggleDetails(): void {
    this.expanded = !this.expanded;
  }

  trackAction(_: number, rule: InvoiceActionRule): InvoiceAction {
    return rule.action;
  }
}
